import React from 'react'

const Studio = ({ media, loaded }) => {
  console.log(media)
return (media === null || !loaded) 
? <div>Loading . . .</div> 
: ( 
<div className='studioCol'>
    <div className='studioRow'>
      <img className='image' src={media[6].media_url} />
      <div className='studioImageDivider'/>
      <img className='image' src={media[5].media_url} />
    </div>

    <div className='studioRow'>
      <img className='image' src={media[3].media_url} />
      <div className='studioImageDivider'/>
      <img className='image' src={media[4].media_url} />
    </div>
    <div className='studioRow'>
      <img className='image' src={media[0].media_url} />
      <div className='studioImageDivider'/>
      <img className='image' src={media[1].media_url} />
    </div>
</div> )
}

export default Studio

